import React from 'react';
import { Link } from 'react-router-dom';
import { FadeIn } from '../FadeIn';
import { ArrowRight, Download, Headphones, BookOpen } from 'lucide-react';
export function FreeResourcesHome() {
  return <section className="py-16 md:py-24 bg-white overflow-hidden relative" data-id="element-516">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-517">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-3xl" data-id="element-518"></div>
      </div>

      <div className="max-w-[1100px] mx-auto px-6 md:px-8 relative z-10" data-id="element-519">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16 max-w-[720px] mx-auto" data-id="element-520">
          <FadeIn data-id="element-521">
            <div className="inline-block px-4 py-1.5 rounded-full border border-forest/20 mb-6 bg-forest/5" data-id="element-522">
              <span className="font-display text-xs font-semibold tracking-widest uppercase text-forest" data-id="element-523">
                Resurse Gratuite
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6 leading-tight" data-id="element-524">
              Cadoul meu pentru tine
            </h2>

            <p className="text-[19px] text-charcoal/80 font-sans leading-relaxed" data-id="element-525">
              Două instrumente blânde care te însoțesc în drumul către tine: un
              ghid de prim ajutor emoțional și o meditație de împământare.
            </p>
          </FadeIn>
        </div>

        {/* Two resource cards with small round photos */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12" data-id="element-526">
          {/* eBook */}
          <FadeIn delay={0.1} data-id="element-527">
            <div className="bg-ivory border border-forest/10 rounded-[28px] p-7 md:p-8 h-full flex flex-col items-center text-center hover:shadow-xl transition-all duration-500 hover:-translate-y-1" data-id="element-528">
              {/* Round photo in gold ring frame */}
              <div className="relative mb-6" data-id="element-529">
                <div className="w-32 h-32 md:w-36 md:h-36 rounded-full overflow-hidden border-4 border-gold/40 shadow-md" data-id="element-530">
                  <img src="https://cdn.magicpatterns.com/uploads/evDwG7z43w5PHEtDALy7Je/ghid_prim_ajutor_square.jpg" alt="Ghidul de Prim Ajutor Emoțional" className="w-full h-full object-cover" data-id="element-531" />
                </div>
                <div className="absolute -bottom-1 -right-1 w-10 h-10 rounded-full bg-forest flex items-center justify-center shadow-md" data-id="element-532">
                  <BookOpen className="w-5 h-5 text-ivory" data-id="element-533" />
                </div>
              </div>

              <span className="font-display text-xs font-semibold tracking-widest uppercase text-gold-dark mb-2" data-id="element-534">
                eBook A.R.I.S.E.
              </span>
              <h3 className="text-xl md:text-2xl font-serif font-medium text-forest mb-3 leading-tight" data-id="element-535">
                Ghidul de Prim Ajutor Emoțional
              </h3>
              <p className="text-[18px] text-charcoal/75 leading-relaxed mb-6 flex-grow" data-id="element-536">
                5 tehnici simple pe care le poți folosi atunci când simți că
                anxietatea sau stresul preiau controlul.
              </p>
              <a href="https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201." target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-forest text-ivory font-display font-medium text-[15px] hover:bg-forest-dark transition-colors no-underline" data-id="element-537">
                <Download className="w-4 h-4" data-id="element-538" />
                Descarcă PDF
              </a>
            </div>
          </FadeIn>

          {/* Meditation Audio */}
          <FadeIn delay={0.2} data-id="element-539">
            <div className="bg-ivory border border-forest/10 rounded-[28px] p-7 md:p-8 h-full flex flex-col items-center text-center hover:shadow-xl transition-all duration-500 hover:-translate-y-1" data-id="element-540">
              {/* Round photo in gold ring frame */}
              <div className="relative mb-6" data-id="element-541">
                <div className="w-32 h-32 md:w-36 md:h-36 rounded-full overflow-hidden border-4 border-gold/40 shadow-md" data-id="element-542">
                  <img src="https://cdn.magicpatterns.com/uploads/sijPPqRzFcNSfpb6eHG5Ta/meditatie_impamanare_square.jpg" alt="Meditație pentru Împământare" className="w-full h-full object-cover" data-id="element-543" />
                </div>
                <div className="absolute -bottom-1 -right-1 w-10 h-10 rounded-full bg-forest flex items-center justify-center shadow-md" data-id="element-544">
                  <Headphones className="w-5 h-5 text-ivory" data-id="element-545" />
                </div>
              </div>

              <span className="font-display text-xs font-semibold tracking-widest uppercase text-gold-dark mb-2" data-id="element-546">
                Meditație audio
              </span>
              <h3 className="text-xl md:text-2xl font-serif font-medium text-forest mb-3 leading-tight" data-id="element-547">
                Meditație pentru Împământare
              </h3>
              <p className="text-[18px] text-charcoal/75 leading-relaxed mb-6 flex-grow" data-id="element-548">
                Un audio ghidat de 10 minute pentru momentele în care te simți
                deconectată și ai nevoie să revii în prezent.
              </p>
              <a href="https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201." target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-forest text-ivory font-display font-medium text-[15px] hover:bg-forest-dark transition-colors no-underline" data-id="element-549">
                <Headphones className="w-4 h-4" data-id="element-550" />
                Ascultă Audio
              </a>
            </div>
          </FadeIn>
        </div>

        {/* See all resources CTA */}
        <FadeIn delay={0.3} data-id="element-551">
          <div className="flex justify-center" data-id="element-552">
            <Link to="/resursegratuite" className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full border-2 border-forest/30 text-forest font-display font-medium text-[17px] hover:bg-forest/5 transition-all duration-300 no-underline" data-id="element-553">
              Vezi toate resursele
              <ArrowRight className="w-5 h-5" data-id="element-554" />
            </Link>
          </div>
        </FadeIn>
      </div>
    </section>;
}